import React, { useEffect,useRef } from "react";
import { Link } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS CSS
import GDPR from './images/GDPR-Compliance.webp'
import ISO from './images/iso-27001-2013-certification-service.png'
import SOC from './images/AICPA-Logo.png'
import FED from './images/1733434523634.png'
import partner1 from './images/images-removebg-preview.png'
import partner2 from './images/images__1_-removebg-preview.png'
import partner3 from './images/opentext-logo-1-scaled.webp'
import partner4 from './images/Blue-Prism-logo_white.png'
import partner5 from './images/Logo-sap-white.png'
import partner6 from './images/partner6.2bed22137123047e9929a5ebcfc0651e.svg'
import partner7 from './images/NOW_BIG.D-65193478.png'
import partner8 from './images/partner8.0c5f0fd24678beddcc1f9a498df8a68d.svg'
import partner9 from './images/APPN_BIG.D-de40bb8d.png'
// import cyber from './images/dATA-removebg-preview.png'
import InformaticaImage from './images/Informatica logo.png'
import MicrosoftCopilotImage from './images/Microsoft Copilot.png';
import SalesforceImage from './images/Salesforce Solutions.png';
// import SAP from './images/SAP-removebg-preview.png'
import SAP from './images/SAP BTPHANA.png'
import cube from './images/cube-removebg-preview.png'
import CountUp from "react-countup";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger"; 
import circle from './images/abstract-shape (2).png'
import homebg from './images/Home-bg-image.png'
// import AI from './images/AI-Powered_Data_Analytics_3-removebg-preview.png'
import GenAI from './images/GenAI & Agentic AI.png'




gsap.registerPlugin(ScrollTrigger);
const ScrollAnimation = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;

    gsap.fromTo(
      section,
      { opacity: 0, y: 100 }, // Start state
      {
        opacity: 1,
        y: 0,
        duration: 1.5,
        ease: "power3.out",
        scrollTrigger: {
          trigger: section,
          start: "top 80%", // When the element is 80% in the viewport
          end: "bottom 30%", // When the element is 30% out of the viewport
          scrub: true, // Smooth scroll animation
        },
      }
    );
  }, []);

}
const Home = () => {
  
  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); 
    
    
  }, []);

  useEffect(() => {
    document.title = "Cognifyar Technologies - Empowering Businesses";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Cognifyar Technologies offers AI-driven solutions in Cloud, DevOps, Digital Transformation, and more."
      );
    }
  }, []);
  
  return (
    
   <main className="home">
      {/* Hero Section */}
      <header className="hero">
  <div className="hero-content" data-aos="fade-up" data-aos-delay="400">
    <h1>Pioneering Future <br /> Solutions Today</h1>
    <p>
       Enhancing business growth through AI-driven solutions, cutting-edge digital innovations, and optimized infrastructure to elevate customer engagement.
    </p>
  </div>

  <div className="hero-image" data-aos="fade-up" data-aos-delay="600">
    {/* Container for the right-side design */}
    <div className="image-container">
      {/* Background circular GIF */}
      {/* <img src={round} alt="Animated GIF" className="background-gif" /> */}

      {/* Foreground image */}
      <img src={homebg} alt="Hero Robot" className="foreground-image" />
    </div>
  </div>
</header>

      {/* About Section */}
      <section className="about-section">
      <div className="about-content">
        <div className="about-text">
          <h3 data-aos="fade-right">About Us</h3>
          <h1 data-aos="fade-right">Empowering Your Vision with Cognifyar Technologies</h1>
          
        <Link to='/About'><button className="shadow-rotating-button">Discover Now <span>↗</span></button></Link> 
        </div>
        <div className="about-image">
        <p data-aos="fade-up">
        Cognifyar Technologies transforms operations, optimizes workflows, and boosts efficiency with cutting-edge AI-powered solutions that propel company success. We automate tedious operations, optimize workflows, and offer useful insights that enable businesses to make informed decisions. Through cost reduction and infrastructure optimization, we assist companies in increasing productivity and maintaining their competitiveness. In order to ensure sustainable growth, our customized solutions raise customer service, improve supply chain management, and increase consumer engagement. We help businesses adjust to changing market demands by fostering a dedication to ongoing innovation. Creating individualized experiences that promote client happiness and loyalty is our main goal. We guarantee long-term success whether it be through process optimization or the discovery of new prospects.Together, we pave the way for a smarter, more efficient future.
          </p>

          {/* <p data-aos="fade-up">
          Our solutions are tailored to elevate customer engagement, providing personalized experiences that drive customer loyalty and satisfaction. Whether it’s enhancing supply chain management or improving customer service, we ensure that businesses achieve sustainable growth and long-term success. Our commitment to innovation ensures continuous improvement and adaptation to evolving market needs. With Cognifyar Technologies as a partner, companies can confidently navigate the complexities of the digital age. Together, we pave the way for a smarter, more efficient future.
          </p> */}
        </div>
      </div>
    </section>

    <section className="services">
  <h2>Our Services</h2>
  <h3>Igniting Your Business Growth</h3>
  <div className="services-grid">
    <div className="card" data-aos="zoom-in" data-aos-delay="200">
      <div className="octagon-container">
        <div className="octagon">
          <img src={MicrosoftCopilotImage} alt="Microsoft Copilot" className="octagon-image" />
        </div>
      </div>
      <h4>Microsoft Copilot</h4>
      <p>
        Transform productivity with AI-powered assistance. Our Microsoft Copilot solutions 
        integrate seamlessly with your workflows to enhance efficiency and decision-making.
      </p>
    </div>
    <div className="card" data-aos="zoom-in" data-aos-delay="200">
      <div className="octagon-container">
        <div className="octagon">
          <img src={SalesforceImage} alt="Salesforce" className="octagon-image"/>
        </div>
      </div>
      <h4>Salesforce Solutions</h4>
      <p>
        End-to-end Salesforce implementation, customization and optimization to 
        revolutionize your customer relationship management and business processes.
      </p>
    </div>
  </div>
  <div className="services-grid1">
    <div className="card" data-aos="fade-up" data-aos-delay="400">
      <div className="octagon-container">
        <div className="octagon">
          <img src={InformaticaImage } alt="Informatica Cloud" className="octagon-image" />
        </div>
      </div>
      <h4>Informatica Cloud</h4>
      <p>
        Cloud-based data integration and management solutions that empower your 
        organization with clean, accessible and actionable data across platforms.
      </p>
    </div>
    <div className="card" data-aos="fade-up" data-aos-delay="600">
      <div className="octagon-container">
        <div className="octagon">
          <img src={GenAI} alt="GenAI & Agentic AI" className="octagon-image" />
        </div>
      </div>
      <h4>GenAI & Agentic AI</h4>
      <p>
        Cutting-edge generative AI and autonomous agent solutions that create content, 
        automate processes, and make intelligent decisions for your business.
      </p>
    </div>
    <div className="card" data-aos="fade-up" data-aos-delay="800">
      <div className="octagon-container">
        <div className="octagon">
          <img src={SAP} alt="SAP BTP/HANA" className="octagon-image" />
        </div>
      </div>
      <h4>SAP BTP/HANA</h4>
      <p>
        Comprehensive SAP Business Technology Platform and HANA services including 
        implementation, migration, and optimization for enterprise-grade solutions.
      </p>
    </div>
  </div>
</section>

      {/* Features Section */}
      <section className="features">
     
        <h2 data-aos="fade-up" data-aos-delay="400">Our Features</h2>
        <h3 data-aos="fade-up" data-aos-delay="400">Bridging business, ideas, and people to create transformative impact.</h3>
        <p data-aos="fade-up" data-aos-delay="400" className="para">
          Cognifyar Technologies simplifies complex challenges to foster seamless collaboration, 
          innovation, and growth. Our solutions empower organizations to make smarter decisions, 
          boost productivity, and achieve sustainable success.
        </p>
        <div className="scroll-container">
          <div className="scroll-content">
            <div className="feature-card">
              <img src={cube} alt="" />
              <h4>Customized AI Solutions</h4>
              <p>
                Leverage AI to create unique solutions that enhance decision-making and business growth.
              </p>
            </div>
            <div className="feature-card">
            <img src={cube} alt="" />
              <h4>Advanced Data Insights</h4>
              <p>
                Harness data for actionable insights that drive innovation and success.
              </p>
            </div>
            <div className="feature-card">
            <img src={cube} alt="" />
              <h4>Enterprise-Level Security</h4>
              <p>
                Ensure security with cutting-edge technologies to protect data and infrastructure.
              </p>
            </div>
            <div className="feature-card">
            <img src={cube} alt="" />
              <h4>Cross-Platform Functionality</h4>
              <p>
                Seamlessly operate across multiple platforms with integrated solutions.
              </p>
            </div>
            <div className="feature-card">
            <img src={cube} alt="" />
              <h4>High-Performance Solutions</h4>
              <p>
                Optimize performance with scalable, high-speed solutions tailored to your needs.
              </p>
            </div>
            <div className="feature-card">
            <img src={cube} alt="" />
              <h4>Cloud-Based Flexibility</h4>
              <p>
              Utilize cloud technologies to enhance scalability, reduce costs, and ensure business continuity.
              </p>
            </div>
            <div className="feature-card">
            <img src={cube} alt="" />
              <h4>Real-Time Analytics</h4> 
              <p>
              Access real-time data analysis to make quick, informed decisions and stay ahead in a fast-paced market.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="who-we-are">
      <div className="stats-grid">
        <div className="stat-card" data-aos="zoom-in"   data-aos-delay="800">
          <h2><CountUp start={0} end={6} duration={30} suffix="+" /></h2>
          <p>Locations</p>
        </div>
        <div className="stat-card" data-aos="zoom-in"  data-aos-delay="800">
          <h2><CountUp start={0} end={100} duration={25} suffix="+" /></h2>
          <p>Team Members</p>
        </div>
        <div className="stat-card" data-aos="zoom-in"  data-aos-delay="800">
          <h2><CountUp start={0} end={200} duration={30} suffix="+" /></h2>
          <p>Resources</p>
        </div>
        <div className="stat-card" data-aos="zoom-in"   data-aos-delay="800">
          <h2><CountUp start={0} end={10} duration={25} suffix="+" /></h2>
          <p>Projects</p>
        </div>
      </div><br/>

      <div className="text-container">
        <h1 data-aos="fade-up">Who We Are</h1>
        <h2 data-aos="fade-up">Visionaries of Innovation</h2>
        <p data-aos="fade-up">
          Cognifyar Technologies empowers businesses with AI-driven solutions that bridge the gap between evolving needs and customer engagement. 
          With a proven track record of over 200 successful projects, we deliver personalized innovations to meet unique challenges. 
          Our dynamic global team works relentlessly to ensure business growth and success. We focus on transforming ideas into impactful solutions. 
          Cognifyar is dedicated to helping businesses thrive and lead in the digital age.
        </p>
      </div>
     
    </section>

    <section className="certification-section">
      <div className="certification-text">
        <h2>Trusted, enterprise-level security protects your data.</h2>
        {/* <button className="certification-button">View Certification</button> */}
      </div>
      <div className="certification-cards">
      <div className="cert-card" data-aos="flip-left" data-aos-delay="400">
          <img src={SOC} alt="SOC2 Type II Verified" />
          <h3>SOC2 Type II Verified</h3>
        </div>
        <div className="cert-card" data-aos="flip-left" data-aos-delay="500">
          <img src={GDPR} alt="GDPR Compliant" />
          <h3>GDPR Compliant</h3>
        </div>
        <div className="cert-card" data-aos="flip-left" data-aos-delay="600">
          <img src={ISO} alt="ISO 27001 Certified" />
          <h3>ISO 27001 Certified</h3>
        </div>
        
        <div className="cert-card" data-aos="flip-left" data-aos-delay="700">
          <img src={FED} alt="FEDRAMP Compliant" />
          <h3>FEDRAMP Compliant</h3>
        </div>
      </div>
    </section>

    <div className="new">
  <section className="why-choose-section">
    <h2 className="section-title" data-aos="fade-up" data-aos-delay="400">
      Why Choose Cognifyar <br></br>
      Technologies?
    </h2>
    <div className="feature-list">
      <div className="feature-item" data-aos="fade-up" data-aos-delay="400">
        <span className="feature-number"><img src={circle} alt="Reliability" /></span>
        <div>
          <h3 className="feature-title">Enterprise-Grade Reliability</h3>
          <p className="feature-description">
          Enterprise-grade solutions built for performance.
          Ensure uninterrupted operations at scale.
          </p>
        </div>
      </div>
      <div className="feature-item" data-aos="fade-up" data-aos-delay="500">
        <span className="feature-number"><img src={circle} alt="Partnership" /></span>
        <div>
          <h3 className="feature-title">Strategic Client Partnership</h3>
          <p className="feature-description">
            Success-driven collaboration model<br />
            delivering measurable, impactful<br />
            business outcomes at scale.
          </p>
        </div>
      </div>
      <div className="feature-item" data-aos="fade-up" data-aos-delay="600">
        <span className="feature-number"><img src={circle} alt="Integration" /></span>
        <div>
          <h3 className="feature-title">Seamless Integration</h3>
          <p className="feature-description">
            Interoperable solutions designed<br />
            for zero-disruption implementation<br />
            across your ecosystem.
          </p>
        </div>
      </div>
      <div className="feature-item" data-aos="fade-up" data-aos-delay="700">
        <span className="feature-number"><img src={circle} alt="Innovation" /></span>
        <div>
          <h3 className="feature-title">Innovation Leadership</h3>
          <p className="feature-description">
            Future-ready technologies that<br />
            transform business potential into<br />
            tangible competitive advantage.
          </p>
        </div>
      </div>
    </div>
  </section>
</div>
<section>

    <div className="partners-section">
      <h2>Our Partners</h2>
      <div className="partners-marquee">
        <div className="marquee-track" data-aos="zoom-out" data-aos-delay="200">
          <img src={partner1} alt="Partner 1" />
          <img src={partner2} alt="Partner 2" />
          <img src={partner3} alt="Partner 3" />
          <img src={partner4} alt="Partner 4" />
          <img src={partner5} alt="Partner 5" />
          <img src={partner6} alt="partner 6" />
          <img src={partner7} alt="partner 7" />
          <img src={partner8} alt="partner 8" />
          <img src={partner9} alt="partner 9" />
        </div>
      </div>
    </div>
    </section>
    <section className="contact-section">
      <div className="contact-content">
        <h1 data-aos="fade-up" data-aos-delay="400">Shaping Your Future, Together</h1>
        <p data-aos="fade-up" data-aos-delay="500">
          At Cognifyar Technologies, we are committed to helping businesses realize their full potential. 
          Our goal is to empower you with innovative tools, advanced technologies, and customized strategies 
          that drive success in today’s fast-paced market. Are you ready to accelerate your digital transformation? 
          Get in touch with us today to learn how Cognifyar Technologies can help you achieve your objectives and ensure long-term growth.
        </p>
     <Link to='/Contact'> <button className="shadow-rotating-button">Take Action</button></Link>
        {/* <a href="/" className="shadow-rotating-button">
          Take Action <span>↗</span>
        </a> */}
      </div>
    </section>
    </main>
  );
};

export default Home;